<template>
  <div>
    <v-row dense class="mb-3">
      <v-col class="pt-0 col-12">
        <v-text-field
            filled
            dense
            label="Título"
            autocomplete="title"
            name="title"
            v-model="company.title"
            :error-messages="errors.title"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12">
        <v-btn-toggle
            dense
            v-model="company.type"
            mandatory
            style="width: 100%"
            color="primary"
        >
          <v-btn
              style="width: 50%"
              value="company"
          >
            Pessoa Jurídica
          </v-btn>
          <v-btn
              style="width: 50%"
              value="person"
          >
            Pessoa Física
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-row
          class="ma-0"
          v-show="company.type === 'company'"
      >
        <v-col class="col-12 col-sm-6 col-md-6">
          <v-text-field
              filled
              dense
              label="Razão Social"
              autocomplete="corporate_name"
              name="corporate_name"
              v-model="company.corporate_name"
              :error-messages="errors.corporate_name"
              prepend-inner-icon="mdi-shield-check"
              hide-details="auto"
              placeholder=" "
              type="text"
          ></v-text-field>
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-6">
          <v-text-field
              filled
              dense
              label="CNPJ"
              autocomplete="corporate_document"
              name="corporate_document"
              v-model="company.corporate_document"
              :error-messages="errors.corporate_document"
              prepend-inner-icon="mdi-file"
              hide-details="auto"
              placeholder=" "
              type="text"
          ></v-text-field>
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-4">
          <v-text-field
              filled
              dense
              label="E-mail"
              autocomplete="corporate_email"
              name="corporate_email"
              v-model="company.corporate_email"
              :error-messages="errors.corporate_email"
              prepend-inner-icon="mdi-email"
              hide-details="auto"
              placeholder=" "
              type="text"
          ></v-text-field>
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-4">
          <v-text-field
              filled
              dense
              label="Site ou Facebook"
              autocomplete="corporate_site"
              name="corporate_site"
              v-model="company.corporate_site"
              :error-messages="errors.corporate_site"
              prepend-inner-icon="mdi-link"
              hide-details="auto"
              placeholder=" "
              type="text"
          ></v-text-field>
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-4">
          <v-text-field
              filled
              dense
              label="Telefone com DDD"
              autocomplete="corporate_phone"
              name="corporate_phone"
              v-model="company.corporate_phone"
              :error-messages="errors.corporate_phone"
              prepend-inner-icon="mdi-phone"
              hide-details="auto"
              placeholder=" "
              type="text"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-row>
    
    <h4>Responsável</h4>
    <v-row dense class="mb-3">
      <v-col class="col-12 col-sm-6 col-md-6">
        <v-text-field
            filled
            dense
            label="Nome Completo"
            autocomplete="manager_name"
            name="manager_name"
            v-model="company.manager_name"
            :error-messages="errors.manager_name"
            prepend-inner-icon="mdi-account-circle"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-6">
        <v-text-field
            filled
            dense
            label="CPF"
            autocomplete="manager_document"
            name="manager_document"
            v-model="company.manager_document"
            :error-messages="errors.manager_document"
            prepend-inner-icon="mdi-fingerprint"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-4">
        <v-text-field
            filled
            dense
            label="E-mail do responsável"
            autocomplete="manager_email"
            name="manager_email"
            v-model="company.manager_email"
            :error-messages="errors.manager_email"
            prepend-inner-icon="mdi-email"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-4">
        <v-text-field
            filled
            dense
            label="Celular com DDD"
            autocomplete="manager_mobile"
            name="manager_mobile"
            v-model="company.manager_mobile"
            :error-messages="errors.manager_mobile"
            prepend-inner-icon="mdi-cellphone"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6 col-md-4">
        <v-text-field
            filled
            dense
            label="Data Nascimento do responsável"
            autocomplete="manager_birthday"
            name="manager_birthday"
            v-model="company.manager_birthday"
            :error-messages="errors.manager_birthday"
            prepend-inner-icon="mdi-cake"
            hide-details="auto"
            placeholder=" "
            type="text"
            v-mask="'##/##/####'"
            @focus="$event.target.select()"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <v-row dense class="mb-3" v-if="false">
      <v-col class="col-12 col-sm-12 col-md-6">
        <v-text-field
            filled
            dense
            label="E-mail Financeiro"
            autocomplete="financial_email"
            name="financial_email"
            v-model="company.financial_email"
            :error-messages="errors.financial_email"
            prepend-inner-icon="mdi-email-open"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <div
        class="mt-3 ma-0 pa-2 text-right bgalpha"
    >
      <v-btn
          color="gray"
          dark
          @click="$emit('Step', 1)"
          :loading="editState"
          class="mr-2"
      >
        Voltar
      </v-btn>
      <v-btn
        color="success"
        @click="companySave()"
        :loading="editState"
      >
        continuar
      </v-btn>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '../../../components/mixins/dateFormat';

export default {
  mixins: [
    dateFormat
  ],
  mounted() {
    this.companyInfo();
  },
  data() {
    return {
      errors: [],

      editState: false,
      company: {
        id: 0,
        title: '',
        type: '',
        corporate_name: '',
        corporate_document: '',
        corporate_email: '',
        corporate_site: '',
        corporate_phone: '',
        manager_name: '',
        manager_document: '',
        manager_email: '',
        manager_mobile: '',
        manager_birthday: '',
        financial_email: ''
      }
    }
  },
  methods: {
    companyInfo() {
      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,
      };

      this.$api
          .post('/project/company.info', payload)
          .then(response => {
            if (response.data.id) {
              this.company = response.data
              this.company.manager_birthday = this.formatDate(this.company.manager_birthday);
            }
          })
          .catch((error) => {
            this.$root.$emit('GlobalSnackbar', {type: 'error', message: 'Não foi possível carregar o cliente'});
          });
    },
    companySave() {
      this.editState = true;

      let payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,
        company_id: this.company.id,

        type: this.company.type,
        title: this.company.title,
        corporate_name: this.company.corporate_name,
        corporate_document: this.company.corporate_document,
        corporate_email: this.company.corporate_email,
        corporate_site: this.company.corporate_site,
        corporate_phone: this.company.corporate_phone,
        manager_name: this.company.manager_name,
        manager_document: this.company.manager_document,
        manager_email: this.company.manager_email,
        manager_mobile: this.company.manager_mobile,
        manager_birthday: this.parseDate(this.company.manager_birthday),
        financial_email: this.company.financial_email
      }

      this.$api
          .post('/project/company.update', payload)
          .then(response => {
            this.errors = [];

            if (response.data.id) {
              this.$emit('Step', 3);
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    }
  },
}
</script>

<style>
</style>
